/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pale_Bronze_Owl_WeepInputs */

const en_pale_bronze_owl_weep = /** @type {(inputs: Pale_Bronze_Owl_WeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`General`)
};

const de_pale_bronze_owl_weep = /** @type {(inputs: Pale_Bronze_Owl_WeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allgemein`)
};

/**
* | output |
* | --- |
* | "General" |
*
* @param {Pale_Bronze_Owl_WeepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pale_bronze_owl_weep = /** @type {((inputs?: Pale_Bronze_Owl_WeepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pale_Bronze_Owl_WeepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pale_bronze_owl_weep(inputs)
	return de_pale_bronze_owl_weep(inputs)
});